import {PagewebEnv} from './PagewebEnv.interface';
import {createPagewebEnv} from './utils/createPagewebEnv';

// FIXME: preset-env 를 저사양으로 맞추면서 이쪽의 transpile 위치가 호이스팅이 안되는 let 이 되어 오류가 나는 상황. 상세한 원인 파악 전 일단 var 로 고정
// eslint-disable-next-line
var env: PagewebEnv;

export function getEnv() {
  return env;
}

export function initializePagewebEnv(pagewebEnv?: PagewebEnv) {
  // next build 시 이곳에 들어옵니다
  if (!pagewebEnv) {
    env = createPagewebEnv({});
  } else {
    env = pagewebEnv;
  }
}
